export type RetornoGetCombustiveis = Combustiveis[]

export interface Combustiveis {
  redeEspecial: boolean
  descricaoCombustivel: string
  indCombustivel: string
  atualizacaoMaiorDezDias: string
  combustivel: Combustivel
  disponivelParaVenda: number

}

export interface Combustivel {
  codPosto: number
  dscEmail: string
  dscTelefone: string
  precos: Precos
  dscStatusAcordo: string
  codPrecoCombustivel?: number
  datInicio?: string
  datCadastro?: string
  codAcesso?: number
  dscLogin?: string
  datInicioVigente?: string
  datStatusAcordo?: string
  datAprovacao?: string



}

export interface Precos {
  precoUnitario: PrecoUnitario[]
  precoNegociado: PrecoNegociado[]
  precoRedeEspecial: PrecoRedeEspecial[]
  descontoEmReais: number
  descontoEmPorcentagem: number
}



export interface PrecoUnitario {
  id: string
  titulo: string
  descricao: string
  somenteLeitura: boolean 
  negociavel: boolean
  preco?: number
  precoAnterior?: number
}

export interface PrecoNegociado {
  id: string
  preco: number
  precoAnterior: number
  titulo: string
  descricao: string
  somenteLeitura: boolean
  negociavel: boolean
  precoAntigo: string
}


export interface PrecoRedeEspecial {
  id: string
  preco: number
  precoAnterior: number
  titulo: string
  descricao: string
  somenteLeitura: boolean
  negociavel: boolean
  vlrDesconto: number


}

